/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDownloadTimerecordsExportDto } from '../models/work-download-timerecords-export-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimerecorddetailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecorddetailsV1ControllerGetCsvExport()` */
  static readonly TimerecorddetailsV1ControllerGetCsvExportPath = '/v1/timerecorddetails/csvExport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecorddetailsV1ControllerGetCsvExport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV1ControllerGetCsvExport$Response(
    params: {
      body: WorkDownloadTimerecordsExportDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecorddetailsService.TimerecorddetailsV1ControllerGetCsvExportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecorddetailsV1ControllerGetCsvExport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecorddetailsV1ControllerGetCsvExport(
    params: {
      body: WorkDownloadTimerecordsExportDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.timerecorddetailsV1ControllerGetCsvExport$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
